/**
 * Läuft die Oberfläche in der Capacitor-App oder im Browser?
 *
 * Relevant, wo sich beide unterscheiden. Der wichtigste Fall ist
 * Ziehen-zum-Aktualisieren: Android-Browser bringen das mit, der Webview der
 * App nicht. Doppelt eingebaut würde es sich im Browser gegenseitig ins
 * Gehege kommen.
 */
export const istApp = () =>
  typeof window !== 'undefined'
  && (window.Capacitor?.isNativePlatform?.() === true
      || Boolean(window.Capacitor?.isNative));

/** Grobe Prüfung auf Zeigereingabe per Finger. */
export const hatTouch = () =>
  typeof window !== 'undefined'
  && ('ontouchstart' in window || navigator.maxTouchPoints > 0);
